import React, { Component } from 'react';

import InputButton from '../../../../../../components/ZUILib/InputButton';

import commonUtil from './../../../../../../utils/commonUtil';

const channel = commonUtil.getChannel();

class ButtonsFooter extends Component {
  render() {
    const device = (channel === 'web');
    const buttonForCancel = {
      type: 'button',
      value: 'Cancelar',
      autoFocus: false,
      style: 'btnSecondaryAction',
      onClickHandler: this.props.cancelAddressModified,
    };

    const buttonForSave = {
      type: 'button',
      value: 'Guardar',
      autoFocus: false,
      style: 'btnPrimaryAction',
      onClickHandler: this.props.hanldeAddressCelebrityMapping,
    };

    const stylesButtons = {
      fontSize: '18px',
      height: '46px',
      textAlign: 'center',
      width: '100%',
      padding: '0 57px',
    };

    return (
      <div
        className="row addressButtonsBlock"
        style={{
          display: (this.props.isModified) ? 'block' : 'none',
          marginTop: device ? 0 : 20,
        }}
      >
        <div
          className="col-sm-9"
          style={{
            display: 'flex',
            flexDirection: device ? 'row' : 'column',
            gap: 10,
            marginBottom: 10,
          }}
        >
          <div
            id="cancelCelebritySelected"
            className="addressButtons"
            ref={this.props.setRef}
          >
            <InputButton
              buttonAttr={buttonForCancel}
              cssStyle={stylesButtons}
            />
          </div>

          <div
            id="saveCelebritySelected"
            className="addressButtons"
            ref={this.props.setRef}
          >
            <InputButton
              buttonAttr={buttonForSave}
              cssStyle={stylesButtons}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ButtonsFooter;
